export const TEXTS = {
  MODAL_VIDEO_REQUEST_BUTTON_TEXT: 'Запросить подключение',
  MODAL_BIND_BUTTON_SUBMIT_TEXT: 'Запустить видеоволну',
  MODAL_BIND_START_DEMO_PERIOD_TEXT: 'Попробовать на демо-адресе',
  MODAL_BIND_ADD_NEW_POINT_TEXT: 'Добавить новый адрес',
  MODAL_BIND_START_DEMO_PERIOD_SUCCESS_TEXT: 'Демо-адрес создан',
};
